import { applyMiddleware, createStore, Store } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'connected-react-router/immutable';
import { loadUser, userFound } from 'redux-oidc';
import { UserManager } from 'oidc-client';
import { LOCAL_STORAGE, SESSION_STORAGE } from '@constants/common';
import { mapAccountLoginToOidcUser } from './actions/account.actions';
import { rootReducer } from './reducers';

const configureStore = (state: any, history: any, userManager: UserManager): Store<any> => {
  let appliedMiddlewares;
  const middlewares = [];
  middlewares.push(thunkMiddleware);
  middlewares.push(routerMiddleware(history));
  if (process.env.NODE_ENV !== 'production'){
    // If not in PROD use logger and devtools middlewares
    const { createLogger } = require('redux-logger'); // eslint-disable-line

    const loggerMiddleware = createLogger({
      stateTransformer: (state: any) => state.toJS()
    });

    middlewares.push(loggerMiddleware);
    appliedMiddlewares = composeWithDevTools(
      applyMiddleware(...middlewares)
    );
  } else {
    appliedMiddlewares = applyMiddleware(...middlewares);
  }

  const store = createStore(rootReducer(history), state, appliedMiddlewares);
  if (typeof window !== 'undefined') {
    const storedOidcUser = sessionStorage.getItem(SESSION_STORAGE.OIDC_USER);
    let restoredUser = false;
    if (storedOidcUser) {
      try {
        store.dispatch(userFound(JSON.parse(storedOidcUser)));
        restoredUser = true;
      } catch (error) {
        sessionStorage.removeItem(SESSION_STORAGE.OIDC_USER);
      }
    }
    if (!restoredUser) {
      try {
        const accessToken = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN);
        const storedAccountInfo = localStorage.getItem(LOCAL_STORAGE.USER_INFO);
        if (accessToken && storedAccountInfo) {
          const oidcUser = mapAccountLoginToOidcUser(accessToken, JSON.parse(storedAccountInfo));
          sessionStorage.setItem(SESSION_STORAGE.OIDC_USER, JSON.stringify(oidcUser));
          store.dispatch(userFound(oidcUser));
          restoredUser = true;
        }
      } catch (error) {
        localStorage.removeItem(LOCAL_STORAGE.ACCESS_TOKEN);
        localStorage.removeItem(LOCAL_STORAGE.USER_INFO);
      }
    }
    if (!restoredUser) {
      loadUser(store, userManager);
    }
  } else {
    loadUser(store, userManager);
  }
  store.dispatch({ type: 'INIT_APP' });
  return store;
};

export default configureStore;